import { SwitchButton } from "../../../../../common/components/switch-button/SwitchButton";
import styles from "../unit-threshold-setup.module.scss";

interface CardHeaderRowProps {
	title: string;
	subtitle: string;
	isOn: boolean;
	isLoading?: boolean;
	disabled?: boolean;
	onToggle: (val: boolean) => void;
}

export const CardHeaderRow = ({ title, subtitle, isOn, isLoading, disabled, onToggle }: CardHeaderRowProps) => {
	return (
		<div className={styles.cardHeader}>
			<div className={styles.cardHeaderLeft}>
				<span className={styles.cardTitle}>{title}</span>
				<span className={styles.cardSubtitle}>{subtitle}</span>
			</div>
			<SwitchButton type="secondary" isActive={isOn} onChange={onToggle} isLoading={isLoading} disabled={disabled} />
		</div>
	);
};
